<template>
  <div>
    <div class="container-fluid right_wrapper">
      <CommonHeader class="main_head_block">
        <template v-slot:header>
          <span class="module_heading">{{ showType() }}</span>
        </template>
      </CommonHeader>
      <div class="table_wrap no_footer pt-2">
        <div
          class="spinner-border"
          v-if="isLoading"
          style="margin-top:20%;margin-left:50%"
        ></div>
        <form v-else  v-on:submit.prevent class="main_form_block">
          <div style="border:1px #0000002e solid; padding:20px" class = "col-sm-11">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">
                Type
                <sup>*</sup>
              </label>
              <div class="col-sm-7 pr-5" style="text-transform:capitalize">
                <multiselect
                  style="padding:0px;padding-left:3px;height:0px"
                  v-model="type"
                  class="form-control multi-dropdown select_filter"
                  placeholder="Select Type"
                  deselectLabel
                  selectedLabel
                  selectLabel
                  openDirection="below"
                  :options="typeList"
                  ref="multiselect"
                  :class="{
                    'is-invalid':
                      submitted && (!type || type == '' || type == 'null'),
                  }"
                ></multiselect>
                <span
                  v-if="submitted && (!type || type == '' || type == 'null')"
                  class="invalid-feedback"
                  >This field is required</span
                >
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">
                Title
                <sup>*</sup>
              </label>
              <div class="col-sm-7 pr-5">
                <input
                  v-on:keydown.enter.prevent
                  type="text"
                  name="entityId"
                  v-model="title"
                  class="form-control"
                  id="resourceTitle"
                  placeholder="Enter title"
                  :class="{
                    'is-invalid': submitted && (!title || title == ''),
                  }"
                />
                <span
                  v-if="submitted && (!title || title == '')"
                  class="invalid-feedback"
                  >This field is required</span
                >
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-2 col-form-label" style="padding-top:0px">
                <label class="form-check-label" for="exampleCheck1"
                  >Release Date <sup>*</sup>
                </label>
              </div>
              <div
                class="col-sm-3 input-append date"
                style="padding-top:0px"
                id="datetimepicker"
              >
                <!-- <input type="text" value=""  data-date-format="yyyy-mm-dd hh:ii" >
							  <span class="add-on"><i class="icon-th"></i></span> -->
                <!--
							  <input
								  type="date"
								  id="datePicker"
								  name="description_date"
								  v-model="description_date"
								  :min="min_date"
								  placeholder="yyyy-mm-dd"
								  class="form-check-input form-control"
								  :class="{ 'is-invalid': submitted && toggleDateValidation && (!description_date || description_date == '' || description_date == null)}"
								  style = "border: 1px #ced4da solid;margin:0px;border-radius: .25rem"

								  > -->
                <b-form-datepicker
                  id="datePicker"
                  placeholder="MM-DD-YYYY"
                  name="description_date"
                  v-model="description_date"
                  menu-class="w-100"
                  size="sm"
                  :date-format-options="{
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  }"
                  calendar-width="160%"
                  :hide-header="true"
                  :min="min_date"
                  locale="en"
                  :class="{
                    'is-invalid':
                      submitted &&
                      toggleDateValidation &&
                      (!description_date ||
                        description_date == '' ||
                        description_date == null),
                  }"
                >
                </b-form-datepicker>
                <span
                  v-if="
                    submitted &&
                      toggleDateValidation &&
                      (!description_date ||
                        description_date == '' ||
                        description_date == null)
                  "
                  class="invalid-feedback"
                  >This field is required</span
                >
              </div>
            </div>
            <div
              class="form-group row"
              :class="{
                'is-invalid': submitted && onEditorCheck(editorData),
              }"
            >
              <label class="col-sm-2 col-form-label">
                Description
                <sup>*</sup>
              </label>
              <div class="col-sm-7 pr-5">
                <ckeditor
                  v-model="editorData"
                  @focus="onEditorFocus"
                  :config="editorConfig"
                  id="textAreaEditor"
                ></ckeditor>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-2"></div>
              <span
                class="col-sm-3 no-data-style"
                v-if="submitted && onEditorCheck(editorData) && toggleDesc"
                >This field is required</span
              >
            </div>
          </div>

          <div class="text-center" style="padding-top:30px;padding-bottom:20px">
            <button
              class="btn btn-secondary"
              @click="navigateToListPage('cancel')"
            >
              Cancel
            </button>
            <button class="btn btn-primary" @click="saveNote()">Save</button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal Starts -->
  </div>
</template>

<script>
import moment from "moment";
import datetimepicker from "bootstrap-datetimepicker-npm";
import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue";
export default {
  name: "AddReleaseNote",
  components: { moment, datetimepicker, Multiselect, CommonHeader },
  data() {
    return {
      title: "",
      isLoading: false,
      isEditPage: false,
      releaseNoteId: "",
      editorConfig: {
        toolbarGroups: [
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "clipboard", groups: ["clipboard", "undo"] },
          { name: "editing", groups: ["find", "selection", "spellchecker"] },
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          { name: "forms" },
          { name: "styles" },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
          },
          { name: "styles" },
          { name: "colors" },
          { name: "tools" },
          { name: "insert" },
        ],
        removeButtons: "Image",
      },
      editorData: "<p>Enter Description</p>",
      description_date: "",
      submitted: false,
      toggleDateValidation: false,
      toggleDesc: false,
      typeList: ["Resource", "Update"],
      type: null,
    };
  },
  watch: {
    isEditPage() {
      if (this.isEditPage) {
        this.getReleaseProfileData();
      }
    },
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "AddEditResourceAndUpdate",
    });

    //$('#datetimepicker').datetimepicker();
    this.checkIsEdit();
  },
  computed: {
    min_date() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    navigateToListPage(data) {
      if (data == "cancel") {
        this.$store.state.calledFromCancel = true;
      }
      this.$router.push({
        path: "/releaseNotes",
      });
    },
    saveNote() {
      this.toggleDateValidation = false;
      this.submitted = true;

      if (this.validate()) {
        let key = Object.keys(CKEDITOR.instances);
        let plain_text = CKEDITOR.instances[key[0]].document
          .getBody()
          .getText();
        this.description_date = moment(this.description_date).format(
          "YYYY-MM-DD"
        );
        let vm = this;
        let payload = {
          title: this.title,
          decription: this.editorData,
          description_date: this.description_date,
          id: this.releaseNoteId,
          plain_description: plain_text,
          type: this.type,
        };

        this.isLoading = true;
        this.$store.dispatch("release/addNote", payload).then((res) => {
          this.$router.push({
            path: "/releaseNotes",
          });
          vm.isLoading = false;
        });
      }
    },
    onEditorFocus(data) {
      if (this.editorData == "<p>Enter Description</p>\n") {
        this.editorData = "";
      }
    },
    onEditorCheck(data) {
      if (
        this.editorData == "<p>Enter Description</p>\n" ||
        this.editorData == "<p>Enter Description</p>" ||
        this.editorData == ""
      ) {
        return true;
      } else if (this.editorData != "<p>Enter Description</p>\n") {
        let key = Object.keys(CKEDITOR.instances);
        if (key && key[0]) {
          var plain_text = CKEDITOR.instances[key[0]].document
            .getBody()
            .getText();
        } else {
          return false;
        }
        if ((plain_text || "").trim() == "") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkIsEdit() {
      let id = this.$route.params.id;
      if (id) {
        this.releaseNoteId = id;
        this.isEditPage = true;
      } else {
        this.isEditPage = false;
      }
    },
    getReleaseProfileData() {
      let vm = this;
      this.isLoading = true;
      this.$store
        .dispatch("release/getNoteById", { id: this.releaseNoteId })
        .then((res) => {
          vm.isLoading = false;
          vm.title = res.title;
          vm.editorData = res.description;
          vm.description_date = res.modified_description_date;
          vm.type = res.type;
        });
    },
    validate() {
      if (
        !this.type ||
        this.type == "" ||
        this.type == "null" ||
        (!this.title || this.title == "") ||
        (!this.description_date || this.description_date == "") ||
        this.onEditorCheck(this.editorData)
      ) {
        if (!this.description_date || this.description_date == "") {
          this.toggleDateValidation = true;
        }
        if (this.onEditorCheck(this.editorData)) {
          this.toggleDesc = true;
        }
        return false;
      } else {
        return true;
      }
    },
    showType() {
      if (this.isEditPage) {
        if (this.type) {
          return `Edit ${this.type}`;
        } else {
          return "Edit";
        }
      } else {
        return `Add Resource/Update`;
      }
    },
  },
};
</script>

<style lang="scss"></style>
